import React from "react";

import { FileSearchByUUID } from "./FileSearchByUUID";

function InternalApp() {
  return (
    <div className="container mx-auto bg-gray-200 rounded-xl shadow border p-8 m-10">
      <p className="text-3xl text-gray-700 font-bold mb-5">Transcript Validation</p>
      <FileSearchByUUID />
    </div>
  );
}

export default InternalApp;
